export default __webpack_public_path__ + "static/media/sample-poster-new.df5a390f.png";